import { useNavigation } from "@/composables/useNavigation";


export function composeArbetsgivareArendetUrl(arendeId: number | string) {
  const navigation = useNavigation();
  const { path, query } = navigation.currentRoute;
  return `${location.protocol}//${location.host}${path}?organisationsnummer=${query.organisationsnummer}&ticket_id=${arendeId}`;
}
